import { InjectionToken } from '@angular/core';
import { LocalCache } from '@nk/caching-lib';
import {
  CompanyEntity,
  PartialCompanyByUuid,
  WatchlistCompanyAggregateEntity,
  WatchlistEntity,
  WithUuid,
} from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface WatchlistApiService {
  watchlistListByCustomerCache: LocalCache<
    WatchlistApiService,
    (customerUuid: string) => Observable<WithUuid<WatchlistEntity>[]>
  >;
  watchlistByUuidCache: LocalCache<
    WatchlistApiService,
    (watchlistUuid: string) => Observable<WithUuid<WatchlistEntity>>
  >;
  postCompanyToWatchlist(
    watchlistUuid: string,
    company: PartialCompanyByUuid,
    returnResultsFlag?: boolean,
  ): Observable<CompanyEntity>;
  postCompaniesToWatchlist(watchlistUuid: string, companies: Partial<CompanyEntity>[]): Observable<CompanyEntity[]>;
  createWatchlist(watchlist: WatchlistEntity): Observable<WithUuid<WatchlistEntity>>;
  fetchWatchlistsByCompanyAndCustomer(
    customerUuid: string,
    companyUuid: string,
  ): Observable<WithUuid<WatchlistEntity>[]>;
  getInsertWarningForWatchlist(watchlistUuid: string): Observable<string[]>;
  fetchWatchlistCompanyAggregateByWatchlist(watchlistUuid: string): Observable<WatchlistCompanyAggregateEntity>;
}
export const WATCHLIST_API_SERVICE_TOKEN = new InjectionToken<WatchlistApiService>('WatchlistApiService');
